module.exports = __webpack_public_path__ + "ui-static/img/cluster-wizard_light.20d26c14.svg";